module.exports = __webpack_public_path__ + "img/six-sigma-logo.36bf6be8.jpg";